import type { USE_CASES_WORDS_EN } from "./use-cases-words-en.ts";

// The use-cases family's Spanish words (ADR-034 point 1): only this family edits them. What every
// use-case page shares sits here; a page's own words sit in its own two files.
export const USE_CASES_WORDS_ES: typeof USE_CASES_WORDS_EN = {
  footerTitle: "Casos de uso",
  home: "Inicio",
  eyebrow: "Caso de uso",
  stepsTitle: "El trabajo, en tres pasos",
  sampleTitle: "Un resultado de ejemplo",
  sampleCaption: "Perfiles inventados y contactos enmascarados: es un ejemplo, no son datos reales.",
  columns: { name: "Nombre y usuario", type: "Tipo", email: "Email", phone: "Teléfono" },
  types: { business: "Negocio", personal: "Personal" },
  noneShown: "no visible",
  getTitle: "Qué obtienes",
  limitTitle: "El límite",
  questionsTitle: "Preguntas y respuestas",
  relatedTitle: "Sigue leyendo",
};
